import { Box, Card, CardContent, Toolbar, Typography} from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import {NavLink} from 'react-router-dom';


const Tabs = (props: any) => {
  const {sections, emitChange, propertyName, tabSelected} = props;

  const updatedTab = (value: any) => {
    emitChange(value);
  };

  return (
    <Card
      sx={{
        height: '60px',
        p: 0,
        m: 0,
        mb: 4,
      }}
    >
      <CardContent
        sx={{
          p: 0,
          m: 0,
          ml: 4,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Breadcrumbs
          sx={{
            p: 0,
            m: 0,
            ml: 4,
            display: 'flex',
            justifyContent: 'flex-start',
            fontWeight: 600,
            fontSize: '18px',
          }}
          aria-label="breadcrumb"
          separator="›"
        >
          <Typography
            sx={{
              '&:hover': {opacity: 0.7},
              transition: '0.2s ease-in-out',
              underline: 'hover',
              color: 'inherit',
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: '18px',
            }}
          >
            <NavLink to="/properties" style={{ textDecoration: 'none', color: 'inherit' }}>Properties</NavLink>
          </Typography>
          <Typography
            sx={{
              transition: '0.2s ease-in-out',
              underline: 'hover',
              color: 'inherit',
              fontWeight: 600,
              fontSize: '18px',
            }}
          >
            {propertyName}
          </Typography>
          <Typography
            sx={{
              transition: '0.2s ease-in-out',
              underline: 'hover',
              color: 'inherit',
              fontWeight: 600,
              fontSize: '18px',
            }}
          >
            {tabSelected === 1
              ? 'Details'
              : tabSelected === 2
              ? 'Financial'
              : tabSelected === 3
              ? 'Media'
              : tabSelected === 4
              ? 'Rentals'
              : 'Publishing'}
          </Typography>
        </Breadcrumbs>
        <Toolbar
          disableGutters
          sx={{
            ml: {
              lg: 6,
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
            }}
          ></Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
            }}
          >
            {sections.map((section: any) => (
              <Typography
                sx={{
                  '&:hover': {opacity: 0.7},
                  transition: '0.2s ease-in-out',
                  mr: 6,
                  color: `${tabSelected === section.value ? '#cc4645' : ''}`,
                  cursor: 'pointer',
                  fontSize: '16px',
                }}
                onClick={() => {
                  updatedTab(section.value);
                }}
                key={section.value}
              >
                {section.title}
              </Typography>
            ))}
          </Box>
        </Toolbar>
      </CardContent>
    </Card>
  );
};

export default Tabs;
